// Shared UI helpers for the Primary pages (same look as PrimaryRouteManage)
import React, { useState, useEffect, useMemo } from 'react';

const ICON_PATHS = {
  route: 'M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M7 17h7a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h7',
  check: 'M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3',
  tick: 'M20 6 9 17l-5-5',
  calendar: 'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
  pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
  eye: 'M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  trash: 'M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14 M10 11v6 M14 11v6',
  grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
  list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
  plus: 'M12 5v14 M5 12h14',
  map: 'M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3z M8 3v15 M16 6v15',
  clipboard: 'M9 4h6v3H9z M7 5H5a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2 M9 13h6 M9 17h4',
  bus: 'M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M3 11h18 M7 21v-3 M17 21v-3 M7 15h.01 M17 15h.01',
  edit: 'M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
  info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01',
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  users: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M23 21v-2a4 4 0 0 0-3-3.9 M16 3.1a4 4 0 0 1 0 7.8',
  building: 'M3 21h18 M5 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16 M15 9h4a1 1 0 0 1 1 1v11 M9 8h2 M9 12h2 M9 16h2',
  mail: 'M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z M22 6l-10 7L2 6',
  phone: 'M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z',
  x: 'M18 6 6 18 M6 6l12 12',
  chevL: 'M15 18l-6-6 6-6',
  chevR: 'M9 18l6-6-6-6',
  chevsL: 'M11 17l-5-5 5-5 M18 17l-5-5 5-5',
  chevsR: 'M13 17l5-5-5-5 M6 17l5-5-5-5',
  refresh: 'M23 4v6h-6 M1 20v-6h6 M3.5 9a9 9 0 0 1 14.9-3.4L23 10 M1 14l4.6 4.4A9 9 0 0 0 20.5 15',
  seat: 'M5 3v10a2 2 0 0 0 2 2h10 M9 3v6h8 M7 19h12',
  link: 'M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7 M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7',
  star: 'M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z',
  // --- icons added so icon-only action buttons never render blank ---
  wallet: 'M20 12V8H6a2 2 0 0 1 0-4h12v4 M4 6v12a2 2 0 0 0 2 2h14v-4 M18 12a2 2 0 0 0 0 4h4v-4z',
  paid: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M15 9.5a3 3 0 0 0-3-1.5c-1.7 0-3 .9-3 2s1.3 1.8 3 2 3 .9 3 2-1.3 2-3 2a3 3 0 0 1-3-1.5 M12 6v2 M12 16v2',
  lock: 'M5 11h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1z M8 11V7a4 4 0 0 1 8 0v4',
  file: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M8 13h8 M8 17h5',
  shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  download: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4 M7 10l5 5 5-5 M12 15V3',
  tag: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z M7 7h.01',
  ticket: 'M3 9a2 2 0 0 0 0 6v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3a2 2 0 0 1 0-6V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1z M13 5v14',
  calc: 'M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z M8 6h8 M8 11h.01 M12 11h.01 M16 11h.01 M8 15h.01 M12 15h.01 M16 15h.01 M8 19h.01 M12 19h.01 M16 19h.01',
  stop: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 8v4 M12 16h.01',
  ban: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M4.9 4.9l14.2 14.2',
  power: 'M18.4 6.6a9 9 0 1 1-12.8 0 M12 2v10',
  history: 'M3 12a9 9 0 1 0 3-6.7L3 8 M3 3v5h5 M12 7v5l3 2',
  all: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
  categories: 'M4 4h6v6H4z M14 4h6v6h-6z M4 14h6v6H4z M17 14v6 M14 17h6',
  driver: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M12 14v8 M10 12L3 10 M14 12l7-2'
};

export const DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const Icon = ({ name, size = 18 }) => (
  <svg className="prm-ico" viewBox="0 0 24 24" width={size} height={size} fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={ICON_PATHS[name]} />
  </svg>
);

export const BusSvg = ({ size = 34 }) => (
  <svg viewBox="0 0 64 34" width={size} height={(size * 34) / 64} aria-hidden="true">
    <rect x="2" y="3" width="58" height="23" rx="7" fill="#f59e0b" />
    <rect x="2" y="19" width="58" height="4" fill="#d97706" />
    <rect x="8" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
    <rect x="19" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
    <rect x="30" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
    <path d="M43 8h10a4 4 0 0 1 4 4v4H43z" fill="#0b1f44" />
    <rect x="57" y="20" width="4" height="3" rx="1" fill="#fff7d6" />
    <circle cx="17" cy="27" r="5.5" fill="#0b1f44" /><circle cx="17" cy="27" r="2.2" fill="#cbd5e1" />
    <circle cx="46" cy="27" r="5.5" fill="#0b1f44" /><circle cx="46" cy="27" r="2.2" fill="#cbd5e1" />
  </svg>
);

export const Switch = ({ checked, onChange, title }) => (
  <label className="prm-switch" title={title}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    <span />
  </label>
);

const useCountUp = (target, duration = 800) => {
  const [value, setValue] = useState(0);
  useEffect(() => {
    let raf, start;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / duration, 1);
      setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);
  return value;
};

export const StatCard = ({ icon, label, value, hint, tone, delay = 0 }) => {
  const shown = useCountUp(value);
  return (
    <div className={`prm-stat tone-${tone}`} style={{ animationDelay: `${delay}ms` }}>
      <div className="prm-stat-icon"><Icon name={icon} size={24} /></div>
      <div className="prm-stat-body">
        <div className="prm-stat-label">{label}</div>
        <div className="prm-stat-value">{shown}</div>
        <div className="prm-stat-hint">{hint}</div>
      </div>
    </div>
  );
};

export const FormSection = ({ n, title, hint, children, delay = 0 }) => (
  <section className="prm-fsec" style={{ animationDelay: `${delay}ms` }}>
    <header className="prm-fsec-head">
      {n && <span className="prm-fsec-num">{n}</span>}
      <div><h4>{title}</h4>{hint && <p>{hint}</p>}</div>
    </header>
    <div className="prm-fsec-body">{children}</div>
  </section>
);

export const Field = ({ label, required, children, full, note }) => (
  <div className={`prm-field ${full ? 'full' : ''}`}>
    {label && <label className="prm-label">{label}{required && <em>*</em>}</label>}
    {children}
    {note && <small className="prm-note">{note}</small>}
  </div>
);

export const Checkbox = ({ label, checked, onChange }) => (
  <label className={`prm-check ${checked ? 'on' : ''}`}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    <span className="box"><Icon name="tick" size={12} /></span>
    <span className="txt">{label}</span>
  </label>
);

export const Avatar = ({ name, src, size = 44 }) => (
  <div className="pbo-avatar" style={{ width: size, height: size, fontSize: size * 0.4 }}>
    {src ? <img src={src} alt={name} /> : (name?.charAt(0)?.toUpperCase() || '?')}
  </div>
);

// ------------------------------------------------------------
// Pagination — ALWAYS visible (even with a single page)
// ------------------------------------------------------------
export const Pagination = ({
  page, pageSize, total, onPage, onPageSize,
  label = 'items', sizes = [5, 10, 25, 50]
}) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  const pages = useMemo(() => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const set = new Set([1, totalPages, page - 1, page, page + 1]);
    const list = [...set].filter(p => p >= 1 && p <= totalPages).sort((a, b) => a - b);
    const out = [];
    list.forEach((p, i) => {
      if (i > 0 && p - list[i - 1] > 1) out.push('…' + p);
      out.push(p);
    });
    return out;
  }, [page, totalPages]);

  return (
    <div className="pbo-pagination">
      <div className="pbo-pg-info">
        Showing <b>{from}–{to}</b> of <b>{total}</b> {label}
        <span className="pbo-pg-page"> · Page {page} of {totalPages}</span>
      </div>
      <div className="pbo-pg-controls">
        <label className="pbo-pg-size">
          Rows
          <select value={pageSize} onChange={(e) => onPageSize(Number(e.target.value))}>
            {sizes.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </label>
        <button className="pbo-pg-btn" onClick={() => onPage(1)} disabled={page === 1} title="First"><Icon name="chevsL" size={15} /></button>
        <button className="pbo-pg-btn" onClick={() => onPage(page - 1)} disabled={page === 1} title="Previous"><Icon name="chevL" size={15} /></button>
        {pages.map(p => typeof p === 'string'
          ? <span key={p} className="pbo-pg-gap">…</span>
          : <button key={p} className={`pbo-pg-num ${p === page ? 'active' : ''}`} onClick={() => onPage(p)}>{p}</button>)}
        <button className="pbo-pg-btn" onClick={() => onPage(page + 1)} disabled={page === totalPages} title="Next"><Icon name="chevR" size={15} /></button>
        <button className="pbo-pg-btn" onClick={() => onPage(totalPages)} disabled={page === totalPages} title="Last"><Icon name="chevsR" size={15} /></button>
      </div>
    </div>
  );
};